/* @flow */
import * as React from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import { makePeopleFilter } from 'chat/lib/ChatSearch';
import { mountIneligibilityAlert } from 'chat/components/PotentialMemberIneligibleDialog';
import { pushRouterToChatWithMember } from 'lib/ChatRouteHelper';
import { rootGroup } from 'entities/RootGroup';
import { SectionHeader } from './StreamSectionList';
import ChatActions from 'chat/actions/ChatActions';
import ChatConstants from 'chat/constants/ChatConstants';
import ChatListSearchItem from 'chat/components/ChatListSearchItem';
import ChatStore from 'chat/stores/ChatStore';
import Group from 'entities/Group';
import PotentialChatMember from 'entities/PotentialChatMember';
import PotentialChatMembers from 'collections/PotentialChatMembers';
import Row from 'components/Row';

type Props = {
  group: Group,
  searchQuery: string,
  onSelect: Function,
};

type State = {
  peopleResults: PotentialChatMembers,
  potentialRecipients: PotentialChatMembers,
};

function getPeopleResults(state: State, query: string = '') {
  const f = makePeopleFilter(query);

  return state.potentialRecipients.filter(f);
}

class StreamSectionListPeople extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static getStores() {
    return [ChatStore];
  }

  static calculateState(prevState: State, props: Props) {
    if (prevState) {
      return {
        potentialRecipients: ChatStore.getMembers(rootGroup),
        peopleResults: getPeopleResults(prevState, props.searchQuery),
      };
    }
    return {
      peopleResults: ChatStore.getMembers(props.group),
      potentialRecipients: ChatStore.getMembers(rootGroup),
    };
  }

  handlePersonSelection = (member: PotentialChatMember) => {
    if (!member.isEligible()) {
      mountIneligibilityAlert(member, this);
      return;
    }

    pushRouterToChatWithMember(this.context.router, member, this.props.group, () => {
      ChatActions.setFocusView(ChatConstants.FocusableViews.HEADER);
    });

    this.props.onSelect();
  };

  renderPersonResult = (member: PotentialChatMember) => {
    return (
      <ChatListSearchItem
        key={member.id}
        member={member}
        query={this.props.searchQuery}
        onSelect={this.handlePersonSelection}
      />
    );
  };

  render() {
    const { peopleResults } = this.state;
    if (!peopleResults || (peopleResults && !peopleResults.length)) {
      return null;
    }
    return (
      <React.Fragment>
        <SectionHeader text="People" />
        <Row size="small">{peopleResults.map(this.renderPersonResult)}</Row>
      </React.Fragment>
    );
  }
}

export const StreamSectionListPeopleContainer = Container.create(StreamSectionListPeople, {
  withProps: true,
  pure: false,
});

export default StreamSectionListPeopleContainer;
